import { Col, Collapse, Row } from 'antd';
import React, { ReactElement, useState } from 'react';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import BuddhiMedUploadListItem from '../fileUpload/BuddhiMedUploadListItem';
import { UploadFile } from 'antd/lib/upload/interface';
import { setBuddhimedSelectedFiles, setModalSwitch, setPreviouslyUploadedFiles, setUploadedFiles } from '../../../store/actions/newAdmissionAction';
import { HIS_UPLOAD_STATUS, NEW_UPLOAD_STATUS, SETTLEMENT_KEY } from '../../constants/crmConstants';
import { centeredNotification, isNonIntegratedPayer } from '../../../utils/utility';
import { migrateToUploadedDoc, getPayerDocs } from '../../../modules/crm/inPatient/service/crmUtils';

const ClassifiedDocumentsRedesign = ({ form, settlementDocuments }: any): any => {
  const { Panel } = Collapse;
  const { newAdmission: { uploadedFiles, selectedFiles, previouslyUploadedFiles, payerDocs }, payerList: { payer },
    admissionDetails: { claimDetails: { nextAllowStatus = [], claimFlowData = [] } } }
    = useSelector((state: RootState): any => state);
  const { totalFileSizeInMB, maxFileCount, shortName, isRpaPayer, isOnMailPayer } = payer;
  const fileCountObject = JSON.parse(totalFileSizeInMB || '{}');
  const nextStatus = nextAllowStatus[0] || 'NEWADMISSION';
  const totalFileSizeInNumber = fileCountObject[nextStatus];
  const maxFileCountObject = JSON.parse(maxFileCount || '{}');
  const numberOfFilesLimit = maxFileCountObject[nextStatus] || 50;

  const [selectedFilesItem, setSelectedFiles] = useState([] as any);
  const dispatch = useDispatch();
  const payerDocuments = getPayerDocs(claimFlowData).filter((file: any): any => {
    return file?.isPayerAttachment;
  });
  const providerDocuments = migrateToUploadedDoc(claimFlowData).filter((file: any): any => {
    return !file?.isPayerAttachment;
  });

  const onFileSelectToggle = (uid: any = '', event?: any, fileItem?: any): any => {
    let files = selectedFilesItem;
    if (uid !== '') {
      files = files?.includes(uid) ? files.filter((f: any): any => f !== uid) : [...files, uid];
    }
    const allSettlementDocs = [...payerDocuments, ...providerDocuments];
    const finalFiles = allSettlementDocs?.filter((file: any): any => {
      return files.includes(file.uid);
    });
    let newData = [...selectedFiles];
    let checkData = [...previouslyUploadedFiles];
    const newUploadedFiles = [...uploadedFiles];

    const tempUploadedFiles = newUploadedFiles?.filter(
      (obj: any): any =>
        (obj?.status === NEW_UPLOAD_STATUS || obj?.status === HIS_UPLOAD_STATUS || !obj?.existingRecord),
    );

    if (shortName === 'SHAI' && (isNonIntegratedPayer(isRpaPayer , isOnMailPayer))) {
      const { fileUploadRemark, claimedAmount, dateOfAdmission, dateOfDischarge, inPatientNumber,
        isDischargeCase: isDischargeCaseForm, settlementType, recieptNo, branch,
        documentType, noOfFiles, selectedOldFile, switchClick } = form?.getFieldsValue(['fileUploadRemark',
          'claimedAmount', 'dateOfAdmission', 'dateOfDischarge', 'inPatientNumber', 'isDischargeCase', 'recieptNo',
          'settlementType', 'branch', 'documentType', 'noOfFiles', 'selectedOldFile', 'switchClick']) || {};
      form?.resetFields();
      form?.setFieldsValue({
        fileUploadRemark, claimedAmount, dateOfAdmission, dateOfDischarge, inPatientNumber,
        isDischargeCase: isDischargeCaseForm, settlementType, recieptNo, branch, documentType,
        noOfFiles, selectedOldFile, switchClick,
      });
    }

    const newFileUploads = uploadedFiles?.filter((file: any): any => (file?.claimStatus === NEW_UPLOAD_STATUS ||
      file?.claimStatus === HIS_UPLOAD_STATUS));
    // to enable/disable the submit button
    if (files?.length > 0) {
      dispatch(setModalSwitch(false));
    } else if (files?.length === 0 && newFileUploads?.length === 0) {
      dispatch(setModalSwitch(true));
    }

    // to validate the size of files uploaded
    let totalUploadedFilesSize = 0;
    const MB2Bytes = 1024 * 1024;
    // // to get the total newly uploaded files' size
    const totalNewlyUploadedFiles = [...newFileUploads, ...finalFiles];
    totalNewlyUploadedFiles.map((file: any): any => {
      totalUploadedFilesSize += file?.size;
    });

    if (numberOfFilesLimit) { // Validation to check the maximum number of files uploaded
      if (event?.target?.checked) { // Only when selecting files
        if (totalNewlyUploadedFiles?.length > numberOfFilesLimit) {
          centeredNotification(`Maximum file allowed is ${numberOfFilesLimit}`);
          return;
        }

        fileItem.isDeleted = false;
        fileItem.isRejected = false;
        fileItem.discrepancy = false;
        fileItem.size = fileItem?.size;
        checkData?.push(fileItem);
        dispatch(setPreviouslyUploadedFiles(checkData));
        // Updating the existingRecord property when validating the uploaded files
        if (tempUploadedFiles?.length < numberOfFilesLimit) {
          // Mark the file as a new record and available document
          fileItem.existingRecord = false;
          fileItem.availableDocument = true;
          // Adding the new file item to the data array
          newData?.push(fileItem);
          dispatch(setBuddhimedSelectedFiles([...newData]));

          // Finding the index of the file in the newData array based on the file's unique identifier (uid)
          // This helps in identifying the file's position within the newData array for further operations
          const objIndex = newData?.findIndex(
            (obj: any): any => obj?.uid === fileItem?.uid,
          );
          // This is used to update the specific file properties in the uploadedFiles array
          const updatedIndex = uploadedFiles?.findIndex(
            (obj: any): any => obj?.uid === fileItem?.uid,
          );

          if (objIndex !== -1) {
            selectedFiles?.splice(objIndex, 1);
            const updatedFiles = [...uploadedFiles];
            // Update the existingRecord and availableDocument properties for the file
            updatedFiles[updatedIndex] = {
              ...updatedFiles[updatedIndex],
              existingRecord: false,
              availableDocument: true,
            };
            dispatch(setUploadedFiles([...updatedFiles]));
          }
        } else {
          centeredNotification(`Maximum file allowed is ${numberOfFilesLimit}`);
        }
      } else { // When deselecting files same logic as when selecting the files
        const objIndex = selectedFiles?.findIndex(
          (obj: any): any => obj?.uid === fileItem?.uid,
        );
        const updatedIndex = uploadedFiles?.findIndex(
          (obj: any): any => obj?.uid === fileItem?.uid,
        );
        const checkedIndex = previouslyUploadedFiles?.findIndex(
          (obj: any): any => obj?.uid === fileItem?.uid,
        );
        // This is used to update the specific file properties in the PayerDocs array
        const payerDocsIndex = payerDocs?.findIndex(
          (obj: any): any => obj?.uid === fileItem?.uid,
        );

        if (checkedIndex !== -1) {
          previouslyUploadedFiles?.splice(checkedIndex, 1);
          dispatch(setPreviouslyUploadedFiles(previouslyUploadedFiles));
        } else {
          checkData = [];
          dispatch(setPreviouslyUploadedFiles(checkData));
        }
        if (objIndex !== -1) {
          selectedFiles?.splice(objIndex, 1);
          const updatedFiles = [...uploadedFiles];
          updatedFiles[updatedIndex] = {
            ...updatedFiles[updatedIndex],
            existingRecord: true,
            availableDocument: false,
          };
          const updatedPayerDocs = [...payerDocs];
          // Update the existingRecord and availableDocument properties for the payr docs
          updatedPayerDocs[payerDocsIndex] = {
            ...updatedPayerDocs[payerDocsIndex],
            existingRecord: false,
            availableDocument: true,
          };
          dispatch(setUploadedFiles([...updatedFiles, ...updatedPayerDocs]));
          dispatch(setBuddhimedSelectedFiles(selectedFiles));
          dispatch(setUploadedFiles([...updatedFiles]));
        } else {
          newData = [];
          dispatch(setBuddhimedSelectedFiles(newData));
        }
      }
    }
    if (totalFileSizeInNumber) {
      if (totalUploadedFilesSize > (totalFileSizeInNumber * MB2Bytes)) {
        centeredNotification(`Maximum total file size limit is ${totalFileSizeInNumber} MB`);
      }
    }

    // set the selected files in the state;
    setSelectedFiles(files);
  };

  const newFileItemUploads = uploadedFiles?.filter((fileUid: any): any => fileUid?.claimStatus === NEW_UPLOAD_STATUS);
  const hisFileUploads = uploadedFiles?.filter((fileUid: any): any => fileUid?.claimStatus === HIS_UPLOAD_STATUS);
  const existingFileUploads = uploadedFiles?.filter((fileUid: any): any => fileUid?.existingRecord === false);
  const totalUploadedFileItems = newFileItemUploads?.length + hisFileUploads?.length + existingFileUploads?.length;
  const currentFormValues = form?.getFieldsValue();
  if (totalUploadedFileItems <= numberOfFilesLimit && selectedFiles?.length) {
    const updatedFormKeyValues = { ...currentFormValues };
    selectedFiles?.forEach((fileItemRecord: any): any => {
      const hasFileUIDs = new Set(selectedFiles?.map((id: any): any => `${SETTLEMENT_KEY}${id?.uid}`));
      Object?.keys(currentFormValues)?.forEach((key: string): any => {
        if (key?.startsWith(SETTLEMENT_KEY)) {
          // Check conditions and update the corresponding field in updatedFormValues
          if (hasFileUIDs?.has(key)) {
            updatedFormKeyValues[key] = key; // Mark checkbox as checked
          } else {
            updatedFormKeyValues[key] = undefined;
          }
        }
      });
    });
    form?.setFieldsValue(updatedFormKeyValues); // Update the form with the final values
  } else {
    // If no files are selected, uncheck all related checkboxes
    Object?.keys(currentFormValues)?.forEach((key: string): any => {
      if (key?.startsWith(SETTLEMENT_KEY)) {
        currentFormValues[key] = undefined;
      }
    });
    form?.setFieldsValue(currentFormValues);
  }

  return (
    <React.Fragment>
      <div className="old-documents-header my-sm">
        {`Available Documents (${payerDocuments?.length + providerDocuments?.length})`}</div>
      <Collapse className="my-sm" expandIconPosition="right" defaultActiveKey={['1']}>
        <Panel header={`1. Payer Documents (${payerDocuments?.length})`} key="payer">
          {
            payerDocuments?.length > 0 ?
              <Row gutter={GUTTOR_SPACE} className="mb-sm">
                <Col md={6}><strong>Documents</strong></Col>
                <Col md={6}><strong>Uploaded on</strong></Col>
                <Col md={4}><strong>Status</strong></Col>
                <Col md={5}><strong>Document type</strong></Col>
                <Col md={3}><strong>Select to submit</strong></Col>
              </Row>
              : null
          }
          {
            payerDocuments?.length > 0 ?
              <div>
                {payerDocuments?.map((file: UploadFile | any, index: number): ReactElement | null =>
                  <BuddhiMedUploadListItem file={file} key={file.uid} index={index} form={form}
                    fileListLength={payerDocuments?.length} selectionAllowed={true}
                    onSelectToggle={onFileSelectToggle} />)}
              </div> : null
          }
        </Panel>
      </Collapse>
      <Collapse className="my-sm" expandIconPosition="right" defaultActiveKey={['1']}>
        <Panel header={`2. Provider Documents (${providerDocuments?.length})`} key="provider">
          {
            providerDocuments?.length > 0 ?
              <Row gutter={GUTTOR_SPACE} className="mb-sm">
                <Col md={6}><strong>Documents</strong></Col>
                <Col md={6}><strong>Uploaded on</strong></Col>
                <Col md={4}><strong>Status</strong></Col>
                <Col md={5}><strong>Document type</strong></Col>
                <Col md={3}><strong>Select to submit</strong></Col>
              </Row>
              : null
          }
          {
            providerDocuments?.length > 0 ?
              <div>
                {providerDocuments?.map((file: UploadFile | any, index: number): ReactElement | null =>
                  <BuddhiMedUploadListItem file={file} key={file.uid} index={index}
                    fileListLength={providerDocuments?.length}
                    selectionAllowed={true} onSelectToggle={onFileSelectToggle} form={form} />)}
              </div> : null
          }
        </Panel>
      </Collapse>
    </React.Fragment>
  );
};
export default ClassifiedDocumentsRedesign;
